"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGD = function FlagGD(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "43.37",
    y: "43.37",
    width: "324.86",
    height: "183.62",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-150.63-79.63,11.8,12.18-150.63,104Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M174.23-79.63,11.8,12.18,174.23,104Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.05,12.18A28.25,28.25,0,1,1,11.8-16.07,28.25,28.25,0,0,1,40.05,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.59-8.52,18,4.73l14,.11a1.88,1.88,0,0,1,1.11,3.39l-11.23,8.3,4.21,13.31a1.88,1.88,0,0,1-2.89,2.1L11.8,23.82.44,31.94a1.88,1.88,0,0,1-2.89-2.1L1.77,16.53-9.47,8.23A1.88,1.88,0,0,1-8.36,4.84l14-.11L10-8.52a1.88,1.88,0,0,1,3.57,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.85-112.62l2.61,7.82,8.25.06a1.12,1.12,0,0,1,.66,2l-6.64,4.9L20.22-90a1.11,1.11,0,0,1-1.71,1.23L11.8-93.52l-6.71,4.8A1.12,1.12,0,0,1,3.38-90l2.49-7.87-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.07,2.61-7.82a1.11,1.11,0,0,1,2.11,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M105.77-112.62l2.61,7.82,8.24.06a1.11,1.11,0,0,1,.66,2l-6.64,4.9L113.13-90a1.11,1.11,0,0,1-1.71,1.23l-6.71-4.79L98-88.73A1.11,1.11,0,0,1,96.29-90l2.49-7.87-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.06,2.61-7.82a1.12,1.12,0,0,1,2.12,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.06-112.62l2.61,7.82,8.25.06a1.12,1.12,0,0,1,.66,2l-6.64,4.9L-72.69-90a1.11,1.11,0,0,1-1.71,1.23l-6.71-4.79-6.71,4.79A1.11,1.11,0,0,1-89.53-90L-87-97.83l-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.06,2.61-7.82a1.11,1.11,0,0,1,2.11,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.85,113l2.61,7.83,8.25.06a1.12,1.12,0,0,1,.66,2l-6.64,4.9,2.49,7.87a1.11,1.11,0,0,1-1.71,1.24l-6.71-4.8-6.71,4.8a1.11,1.11,0,0,1-1.71-1.24l2.49-7.87-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.07L10.74,113a1.11,1.11,0,0,1,2.11,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M105.77,113l2.61,7.83,8.24.06a1.11,1.11,0,0,1,.66,2l-6.64,4.9,2.49,7.87a1.11,1.11,0,0,1-1.71,1.24l-6.71-4.8L98,136.88a1.12,1.12,0,0,1-1.71-1.24l2.49-7.87-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.06,2.61-7.83a1.12,1.12,0,0,1,2.12,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.06,113l2.61,7.83,8.25.06a1.12,1.12,0,0,1,.66,2l-6.64,4.9,2.49,7.87a1.11,1.11,0,0,1-1.71,1.24l-6.71-4.8-6.71,4.8a1.11,1.11,0,0,1-1.71-1.24l2.49-7.87-6.64-4.9a1.11,1.11,0,0,1,.65-2l8.25-.06,2.61-7.83a1.11,1.11,0,0,1,2.11,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-98.54-5.48H-116.2V12.18A17.66,17.66,0,0,0-98.54,29.84,17.66,17.66,0,0,0-80.89,12.18,17.66,17.66,0,0,0-98.54-5.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.89,29.84-90.59,28l-8-15.77,15.77,8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGD;
exports["default"] = _default;